import { f as r } from "../internals/function-apply.js";
import { f as n } from "../internals/function-call.js";
import { f as t } from "../internals/function-uncurry-this.js";
import { f as e } from "../internals/fix-regexp-well-known-symbol-logic.js";
import { a as i } from "../internals/an-object.js";
import { i as s } from "../internals/is-null-or-undefined.js";
import { i as l } from "../internals/is-regexp.js";
import { r as a } from "../internals/require-object-coercible.js";
import { s as o } from "../internals/species-constructor.js";
import { a as f } from "../internals/advance-string-index.js";
import { t as m } from "../internals/to-length.js";
import { t as u } from "../internals/to-string.js";
import { g as p } from "../internals/get-method.js";
import { a as c } from "../internals/array-slice-simple.js";
import { r as g } from "../internals/regexp-exec-abstract.js";
import { r as h } from "../internals/regexp-exec.js";
import { r as d } from "../internals/regexp-sticky-helpers.js";
import { f as x } from "../internals/fails.js";
var j = d.UNSUPPORTED_Y,
  v = Math.min,
  b = [].push,
  y = t(/./.exec),
  I = t(b),
  k = t("".slice);
e("split", function (t, e, d) {
  var x;
  return x = "c" == "abbc".split(/(b)*/)[1] || 4 != "test".split(/(?:)/, -1).length || 2 != "ab".split(/(?:ab)*/).length || 4 != ".".split(/(.?)(.?)/).length || ".".split(/()()/).length > 1 || "".split(/.?/).length ? function (t, i) {
    var s,
      o,
      f,
      m = u(a(this)),
      p = void 0 === i ? 4294967295 : i >>> 0;
    if (0 === p) return [];
    if (void 0 === t) return [m];
    if (!l(t)) return n(e, m, t, p);
    for (var g = [], d = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (t.sticky ? "y" : ""), x = 0, j = RegExp(t.source, d + "g"); (s = n(h, j, m)) && (!((o = j.lastIndex) > x) || (I(g, k(m, x, s.index)), s.length > 1 && s.index < m.length && r(b, g, c(s, 1)), f = s[0].length, x = o, !(g.length >= p)));) j.lastIndex === s.index && j.lastIndex++;
    return x === m.length ? (f || !y(j, "")) && I(g, "") : I(g, k(m, x)), g.length > p ? c(g, 0, p) : g;
  } : "0".split(void 0, 0).length ? function (r, t) {
    return void 0 === r && 0 === t ? [] : n(e, this, r, t);
  } : e, [function (r, e) {
    var i = a(this),
      l = s(r) ? void 0 : p(r, t);
    return l ? n(l, r, i, e) : n(x, u(i), r, e);
  }, function (r, n) {
    var t = i(this),
      s = u(r),
      l = d(x, t, s, n, x !== e);
    if (l.done) return l.value;
    var a = o(t, RegExp),
      p = t.unicode,
      c = (t.ignoreCase ? "i" : "") + (t.multiline ? "m" : "") + (t.unicode ? "u" : "") + (j ? "g" : "y"),
      h = new a(j ? "^(?:" + t.source + ")" : t, c),
      b = void 0 === n ? 4294967295 : n >>> 0;
    if (0 === b) return [];
    if (0 === s.length) return null === g(h, s) ? [s] : [];
    for (var y = 0, w = 0, E = []; w < s.length;) {
      h.lastIndex = j ? 0 : w;
      var R,
        C = g(h, j ? k(s, w) : s);
      if (null === C || (R = v(m(h.lastIndex + (j ? w : 0)), s.length)) === y) w = f(s, w, p);else {
        if (I(E, k(s, y, w)), E.length === b) return E;
        for (var P = 1; P <= C.length - 1; P++) if (I(E, C[P]), E.length === b) return E;
        w = y = R;
      }
    }
    return I(E, k(s, y)), E;
  }];
}, !!x(function () {
  var r = /(?:)/,
    n = r.exec;
  r.exec = function () {
    return n.apply(this, arguments);
  };
  var t = "ab".split(r);
  return 2 !== t.length || "a" !== t[0] || "b" !== t[1];
}), j);